// «Hay una lectura mejorada del plan» (contrato §8). El backend marca `reading_upgrade_available` en
// toda propuesta viva cuya versión de lectura no es la de hoy, también en una abierta sin decisiones
// (esa la regenera sola el sync de la mañana). El aviso dice «Como ya aprobaste o corregiste cambios, no
// la aplicamos sola», así que se muestra sólo cuando eso es cierto: hay aprobados o aplicados, se
// corrigió la lectura, o la propuesta quedó aplicada a medias. Módulo puro para testearlo sin la vista.

const DECIDED_ITEM_STATUSES = new Set(['APPROVED', 'APPLIED']);

// Si el backend manda `has_decisions` resuelto (pedido a `mp-be-reparto`: el mismo criterio que
// `MediaPlanParseService.has_decisions`, que cuenta sólo la revisión CONFIRM), manda él: una sola
// definición. Si no viene, la heurística de abajo, que cuenta cualquier revisión de la lectura.
export function proposalHasDecisions(proposal) {
    if (!proposal) return false;
    if (typeof proposal.has_decisions === 'boolean') return proposal.has_decisions;
    if (proposal.status === 'PARTIALLY_APPLIED') return true;
    if (proposal.interpretation_revision_id) return true;
    return (proposal.items || []).some((item) => DECIDED_ITEM_STATUSES.has(item.review_status));
}

export function readingUpgradeVisible(proposal) {
    return !!(proposal && proposal.reading_upgrade_available) && proposalHasDecisions(proposal);
}
